module.exports = __webpack_public_path__ + "img/1.812c8171.webp";